module.exports = __webpack_public_path__ + "img/web.23db0108.svg";